import React from 'react';
import { Flag } from '@planne-software/uni';
import { IconBuilding, IconUser } from '@tabler/icons-react';

import { CardBrandArt } from '@src/features/payments/components/CardBrandArt';
import PixIcon from '@src/icons/pix.svg';
import type { OrderDetailsFieldAdornment } from '@src/features/orders/details/types';

import { OrderDetailsFieldValueRow, OrderDetailsFieldValueText } from './styles';

const BRAND_ART_WIDTH = 34;

const Adornment = ({ adornment }: { adornment: OrderDetailsFieldAdornment }) => {
  switch (adornment.kind) {
    case 'flag':
      return <Flag code={adornment.code} size={24} />;
    case 'card-brand':
      return <CardBrandArt code={adornment.code} width={BRAND_ART_WIDTH} />;
    case 'pix':
      return <PixIcon width={BRAND_ART_WIDTH} height={24} aria-hidden />;
    default:
      return adornment.accountType === 'company' ? (
        <IconBuilding size={24} aria-hidden />
      ) : (
        <IconUser size={24} aria-hidden />
      );
  }
};

export type OrderDetailsFieldValueProps = {
  value: string;
  adornment?: OrderDetailsFieldAdornment;
};

export const OrderDetailsFieldValue = (props: OrderDetailsFieldValueProps) => {
  const { value, adornment } = props;

  return (
    <OrderDetailsFieldValueRow>
      {adornment ? <Adornment adornment={adornment} /> : null}
      <OrderDetailsFieldValueText title={value}>{value}</OrderDetailsFieldValueText>
    </OrderDetailsFieldValueRow>
  );
};

export default OrderDetailsFieldValue;
